import { render, staticRenderFns } from "./RegLatestPage.vue?vue&type=template&id=d1b3aeea&scoped=true&"
import script from "./RegLatestPage.vue?vue&type=script&lang=js&"
export * from "./RegLatestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b3aeea",
  null
  
)

export default component.exports